var _circle, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShelterCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#12b388"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-836-571h36v36h-36Z",
    transform: "translate(836 571)",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-827.816-574.547h36v36h-36Z",
    transform: "translate(827.816 574.547)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.075 1.162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-808.862-542.687v3.507h-6.322v-3.41c-3.45.47-5.882,1.6-5.882,2.916,0,1.74,4.231,3.15,9.45,3.15s9.45-1.41,9.45-3.15C-802.166-541.094-804.988-542.294-808.862-542.687Z",
    transform: "translate(821.066 570.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-810.412-543.357v-8.016l3.089-2.585.987,5.605,9.37-1.652-.473-2.677-6.693,1.179-1.969-11.165,2.488.9v4.817h2.717v-6.728h-.019l-7.16-2.606a2.759,2.759,0,0,0-1.062-.18,3.558,3.558,0,0,0-3.3,2.475,5.99,5.99,0,0,1-.692,1.607,6.781,6.781,0,0,1-5.426,2.714h-.011v2.719h0a9.5,9.5,0,0,0,7.335-3.465l.947,5.376-2.853,2.394v9.284h2.722",
    transform: "translate(820.816 572.577)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-810.559-567.818a2.719,2.719,0,0,0,2.719-2.72,2.719,2.719,0,0,0-2.719-2.718,2.718,2.718,0,0,0-2.718,2.718v0a2.719,2.719,0,0,0,2.716,2.718h0",
    transform: "translate(820.287 573.256)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShelterCircle);
export default __webpack_public_path__ + "static/media/icon_shelter--circle.a35866e6ca2b6d563f9cf2736410d3f0.svg";
export { ForwardRef as ReactComponent };